import * as z from "zod/v4";

const KlaviyoFlowSchema_ = z.object({
  id: z.string(),
  name: z.string(),
  status: z.string(),
  triggerType: z.string(),
  created: z.string(),
  updated: z.string(),
});

export interface KlaviyoFlowSchema extends z.infer<typeof KlaviyoFlowSchema_> {}

export const KlaviyoFlowSchema: z.ZodType<KlaviyoFlowSchema> =
  KlaviyoFlowSchema_;

export const getKlaviyoFlows = {
  name: "getKlaviyoFlows" as const,
  input: z.object({}),
  output: z.object({ flows: z.array(KlaviyoFlowSchema) }),
};
